import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from './Icons';
import Footer from './Footer';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white font-sans selection:bg-zinc-900 selection:text-white flex flex-col">
      <nav className="w-full px-6 py-4 border-b border-zinc-200 sticky top-0 bg-white/80 backdrop-blur-sm z-20">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-6 h-6 bg-white border-2 border-black rounded-sm flex items-center justify-center">
              <Check className="w-4 h-4 text-black" strokeWidth={3} />
            </div>
            <span className="font-semibold text-lg tracking-tight text-black">GradeMind.ai</span>
          </Link>
        </div>
      </nav>

      <main className="flex-1 w-full max-w-3xl mx-auto px-6 py-12">
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-zinc-900 tracking-tight mb-4">Terms of Service</h1>
          <p className="text-zinc-500">Last updated: March 15, 2024</p>
        </div>

        <div className="prose prose-zinc max-w-none space-y-12">
          <section>
            <h2 className="text-xl font-bold text-zinc-900 mb-4">1. Agreement to Terms</h2>
            <p className="text-zinc-600 leading-relaxed">
              These Terms of Service constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and GradeMind ("we," "us" or "our"), concerning your access to and use of the GradeMind website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-900 mb-4">2. Intellectual Property Rights</h2>
            <p className="text-zinc-600 leading-relaxed">
              Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-900 mb-4">3. User Representations</h2>
            <p className="text-zinc-600 leading-relaxed">
              By using the Site, you represent and warrant that:
            </p>
            <ul className="list-disc list-inside mt-4 space-y-2 text-zinc-600">
              <li>All registration information you submit will be true, accurate, current, and complete.</li>
              <li>You have the legal capacity and you agree to comply with these Terms of Service.</li>
              <li>You are not a minor in the jurisdiction in which you reside.</li>
              <li>You will not access the Site through automated or non-human means.</li>
              <li>You will not use the Site for any illegal or unauthorized purpose.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-900 mb-4">4. Educational Use & Liability</h2>
            <p className="text-zinc-600 leading-relaxed">
              GradeMind is an assistive tool for educators. The grades and feedback generated by our AI models are suggestions based on the criteria provided.
              <br /><br />
              <strong>Important:</strong> The final responsibility for any grade assigned to a student lies solely with the educator. GradeMind is not liable for academic disputes, errors in grading, or the consequences of using AI-generated feedback.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-900 mb-4">5. Data Privacy & Storage Acknowledgement</h2>
            <p className="text-zinc-600 leading-relaxed">
              You acknowledge and agree that:
            </p>
            <ul className="list-disc list-inside mt-4 space-y-2 text-zinc-600">
              <li>Student submission files are stored using secure third-party cloud storage providers.</li>
              <li>Grading data and account information are stored in secure cloud database systems.</li>
              <li>You have obtained all necessary consents/permissions to upload student data to these third-party processors.</li>
              <li>You are solely responsible for sanitizing data (removing PII) if required by your institution's policies.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-900 mb-4">6. Limitation of Liability</h2>
            <p className="text-zinc-600 leading-relaxed">
              To the fullest extent permitted by law, GradeMind shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including data loss, resulting from your use of the service.
              <br /><br />
              We explicitly disclaim liability for any data breaches occurring at our third-party infrastructure providers (cloud storage, database, or AI model providers), provided we have implemented standard security configurations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-900 mb-4">7. Contact Us</h2>
            <p className="text-zinc-600 leading-relaxed">
              If you have any questions about these Terms, please contact us at:
              <br />
              <a href="mailto:legal@grademind.ai" className="text-black font-medium underline">legal@GradeMind.ai</a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Terms;
